// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3NP-c","footer":"ModalError_footer__3_8BS"};